import React, { createContext, useContext, useReducer } from "react";

/**
 * Import Packages
 */
import {
    collection,
    addDoc,
    doc,
    deleteDoc,
    getDocs,
} from "firebase/firestore";

/**
 * Import Hooks
 */
import { useFirestore } from "./FirestoreProvider";
import { useRooms } from "./RoomsProvider";

/**
 * Import Reducers
 */
import {
    gameReducer,
    initialState,
    setActiveSubtitleIndex,
    flagActiveSubtitleIndex,
    setName,
    resetGame,
} from "../reducers/GameReducer";

/**
 * Create Context for Provider
 */
export const GameContext = createContext();

/**
 * Hook for Rooms Context
 *
 * @returns Context
 */
export function useGame() {
    return useContext(GameContext);
}

/**
 *
 * @param {Object} props
 * @returns
 */
export const GameProvider = ({ children }) => {
    /**
     * Get our database
     */
    const { db } = useFirestore();

    /**
     * Get room data (we need this to look in the right place for our groups)
     */
    const { roomsState } = useRooms();

    /**
     * Create gameState & gameDispatch for local data
     */
    const [gameState, gameDispatch] = useReducer(
        gameReducer,
        initialState
        // initializer
    );

    /**
     * Every time the gameState changes, update local storage
     */
    // useEffect(() => {
    //   localStorage.setItem("localGame", JSON.stringify(gameState));
    // }, [gameState]);

    /**
     * Submit answers on database
     */
    const submitAnswers = async (data) => {
        try {
            const response = await addDoc(
                collection(db, "rooms", roomsState.id, "results"),
                { ...data, timestamp: Date.now() }
            );

            console.log(response);
        } catch (err) {
            console.error(err);
        }
    };

    /**
     * Clear all results for a specific room
     */
    const clearResults = async (roomId) => {
        if (!roomId) {
            return;
        }

        try {
            const resultsRef = collection(db, "rooms", roomId, "results");
            const snapshot = await getDocs(resultsRef);

            const deletions = snapshot.docs.map((docSnapshot) =>
                deleteDoc(doc(db, "rooms", roomId, "results", docSnapshot.id))
            );

            await Promise.all(deletions);
        } catch (err) {
            console.error(err);
        }
    };

    /**
     *
     */
    return (
        <GameContext.Provider
            value={{
                gameState,
                gameDispatch,
                setActiveSubtitleIndex,
                flagActiveSubtitleIndex,
                setName,
                submitAnswers,
                clearResults,
                resetGame,
            }}
        >
            {children}
        </GameContext.Provider>
    );
};
